import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
import { Grid } from '@material-ui/core';
export const StyledModalContent = styled('div') `
	padding: ${Magnetic.spacer16};
	display: flex;
	flex-direction: column;
	gap: ${Magnetic.spacer04};
	width: 100%;
`;
export const StyledModalActionList = styled('div') `
	display: flex;
	flex-direction: column;
	margin-left: ${Magnetic.spacer12};
	width: 100%;
	gap: ${Magnetic.spacer04};
	align-items: flex-start;
`;
export const StyledActionButton = styled('button') `
	display: flex;
	align-items: center;
	gap: ${Magnetic.spacer16};
	width: fit-content;
	border: 0;
	background: transparent;
	color: ${props => (props.disabled ? Magnetic.colorNeutral40 : Magnetic.colorBrand50)};
	cursor: ${props => (props.disabled ? Magnetic.disabledCursor : Magnetic.actionableCursor)};
	line-height: 1;
	justify-content: flex-start;
	text-align: left;
	font-size: ${Magnetic.fontSize16};
	opacity: ${props => (props.disabled ? 0.5 : 1)};
	pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;
export const StyledActionIcon = styled('i') `
	width: ${Magnetic.spacer24};
	height: ${Magnetic.spacer24};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${Magnetic.fontSize20};
	line-height: 1;
`;
export const StyledActionLabel = styled('span') `
	font-size: ${Magnetic.fontSize16};
	line-height: ${Magnetic.fontSize24};
	cursor: ${Magnetic.actionableCursor};
`;
export const StyledModalActionButton = styled(StyledActionButton) `
	padding: ${Magnetic.spacer04} 0;
`;
export const StyledModalGridInnerContainer = styled(Grid) `
	background-color: transparent;
	min-height: 500px;
	border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorNeutral20};
`;
export const StyledModalGridPhotoCaptureItem = styled(Grid) `
	width: 100%;
	border: 0;
`;
export const StyledImageLabelSection = styled('div') `
	display: flex;
	flex-direction: column;
	gap: ${Magnetic.spacer04};
	margin: ${Magnetic.spacer12} ${Magnetic.spacer12} ${Magnetic.spacer24};
`;
export const StyledImageLabelHeading = styled('p') `
	font-size: ${Magnetic.fontSize14};
	font-weight: ${Magnetic.fontWeightHeavy};
	margin: 0;
	color: ${Magnetic.colorNeutral50};
`;
export const StyledImageLabelValue = styled('p') `
	font-size: ${Magnetic.fontSize14};
	font-weight: ${Magnetic.fontWeightHeavy};
	margin: 0;
	white-space: normal;
	overflow: visible;
	text-overflow: clip;
	word-break: break-word;
`;
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorThumbnailGallery.style.js.map